import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error('Password troppo corta (min 8)'); return; }
    if (password !== confirm) { toast.error('Le password non coincidono'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success('Password aggiornata!');
      setTimeout(() => navigate('/account'), 2500);
    } catch (e) {
      const msg = e.response?.data?.detail || 'Errore durante il reset';
      toast.error(typeof msg === 'string' ? msg : 'Errore');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F0EBE1] flex items-center justify-center p-4">
      <div data-testid="reset-password-page" className="w-full max-w-sm bg-white rounded-2xl border border-[#E8E3D9] shadow-sm p-6">
        <div className="text-center mb-5">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#C25934]/10 mb-2">
            <Lock size={22} className="text-[#C25934]" />
          </div>
          <h1 className="text-xl font-bold text-[#2A2624]" style={{ fontFamily: 'Outfit' }}>Reimposta password</h1>
          <p className="text-sm text-[#877E78] mt-1">Scegli una nuova password (min 8 caratteri).</p>
        </div>

        {done ? (
          <div className="text-center py-6 space-y-2">
            <CheckCircle2 size={48} className="text-[#4A6B53] mx-auto" />
            <p className="font-semibold text-[#2A2624]">Password aggiornata!</p>
            <p className="text-xs text-[#877E78]">Reindirizzamento al login...</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="text-[10px] font-bold text-[#877E78] uppercase">Nuova password</label>
              <Input
                data-testid="reset-pw-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Min 8 caratteri"
                className="h-11"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-[#877E78] uppercase">Conferma password</label>
              <Input
                data-testid="reset-pw-confirm"
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Ripeti la password"
                className="h-11"
              />
            </div>
            <Button
              data-testid="reset-pw-submit"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-full bg-[#C25934] hover:bg-[#A64B2B] text-white"
            >
              {loading ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : null}
              Aggiorna password
            </Button>

            <Link to="/account" className="block text-center text-xs text-[#877E78] hover:text-[#C25934] mt-2">
              Annulla e torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
